/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { Theme, useMediaQuery } from '@mui/material';
import { AudienceType, newUntargetedParentAudienceProps, newParentAudienceProps, UntargetedParentAudienceProps, ParentAudienceProps } from '../../../../../models/FormProps';
import { isNotEmpty } from '../../../../../utils/equality';
import TargetedCustodianImage from '../../../../../../../assets/images/targeted_untargeted_selector/targeted-custodian.svg';
import UntargetedCustodianImage from '../../../../../../../assets/images/targeted_untargeted_selector/untargeted-custodian.svg';
import AudienceGuide from '../common/AudienceGuide';

interface Props {
  viewableAudience: ParentAudienceProps | UntargetedParentAudienceProps;
  viewOnly: boolean;
  updateViewableAudienceCallback: (viewableAudience: ParentAudienceProps | UntargetedParentAudienceProps) => void;
  formHasResponses: boolean;
  expectedAudience?: AudienceType;
}

export default function TargetedUntargetedCustodianSelector(props: Props): React.ReactElement {
  const { viewableAudience, viewOnly, updateViewableAudienceCallback, formHasResponses, expectedAudience } = props;
  const isMobileOrTablet = useMediaQuery<Theme>(theme => theme.breakpoints.down('lg'));

  const isUnrestricetdAudience = !expectedAudience;

  return (
    <Stack spacing={0}>
      <AudienceGuide />
      <Stack direction={isMobileOrTablet ? 'column' : 'row'} justifyContent="center" alignItems="center" spacing={3} sx={{ mt: '32px' }}>
        {(isUnrestricetdAudience || expectedAudience === AudienceType.PARENT) && (
          <Button
            className={viewableAudience.type === AudienceType.PARENT
              ? 'audience-editor-button-selected' : 'audience-editor-button'}
            variant="outlined"
            onClick={() => selectTargetedAudienceCallback()}
            disabled={viewOnly}
          >
            <img alt="Custodians for specific students only" src={TargetedCustodianImage} className="audience-editor-button-image" />
          </Button>
        )}
        {(isUnrestricetdAudience || expectedAudience === AudienceType.UNTARGETED_PARENT) && (
          <Button
            className={viewableAudience.type === AudienceType.UNTARGETED_PARENT ? 'audience-editor-button-selected' : 'audience-editor-button'}
            variant="outlined"
            onClick={() => selectUntargetedAudienceCallback()}
            disabled={viewOnly}
          >
            <img alt="Custodians for any students" src={UntargetedCustodianImage} className="audience-editor-button-image" />
          </Button>
        )}
      </Stack>
    </Stack>
  );

  function selectTargetedAudienceCallback() {
    if (viewableAudience.type === AudienceType.UNTARGETED_PARENT) {
      if (formHasResponses && !confirm('This will restrict the form audience to custodians of selected students. If you have already collected responses, make sure you select those students in the next page to continue viewing the responses from their custodians. Click to proceed.')) return;
      updateViewableAudienceCallback(newParentAudienceProps({}));
    }
  }

  function selectUntargetedAudienceCallback() {
    if (viewableAudience.type === AudienceType.PARENT) {
      if (isNotEmpty(viewableAudience.entities) && !confirm('This will delete all currently selected groups and individuals. Click to proceed.')) return;
      updateViewableAudienceCallback(newUntargetedParentAudienceProps());
    }
  }
}
